<script>
export default {
    inserted: (el) => {
        let bars = el.querySelectorAll('ul li a');
        let barsList = el.querySelectorAll('ul li');
        let rows = el.querySelectorAll('.row');
        let setOnclick = function(element) {
            element.onclick = function(e) {
                e.preventDefault();
                reset();
                showTab(element.dataset.type);
                element.parentElement.classList.add('active');
            }
        }
        for(let element of bars) {
            setOnclick(element);
        }
        let reset = function() {
            for(let element of barsList) {
                element.classList.remove('active');
            }
            for(let row of rows) {
                row.style.display = 'none';
            }
        }
         let showTab = function(type) {
            for(let row of rows) {
                if(row.dataset.type == type) {
                    row.style.display = 'flex';
                }
            }
        }
    }
}
</script>